




































































































import Vue from 'vue'
import bus from '../model/bus'
import EngramFilter from './EngramFilter.vue'

export default Vue.extend({
    name: 'LootList',
    components: { EngramFilter },
    data() {
        return {
            bus,
            manager: bus.game.LootManager,
            destination: null,
            includeAll: false,
        }
    },
    created() {},
    computed: {
        lootxx() {
            return bus.game.LootManager.list.filter(loot => loot.ItemSetManager.list.length)
        },
    },
    methods: {
        copy(destination) {
            this.destination = destination
            this.$bvModal.show('loot-modal')
        },
        select(loot) {
            this.$bvModal.hide('loot-modal')
            this.destination.ItemSetManager.clear()
            this.destination.ItemSetManager.load(loot.ItemSetManager)
        },
        selectAll() {
            this.includeAll = !this.includeAll
            this.manager.filtered.forEach(loot => (loot.included = this.includeAll))
        },
        setMin() {
            const value = prompt('Please input the Min Amount', '1')
            if (value !== null) {
                this.manager.filtered.forEach(item => {
                    item.MinItemSets = parseInt(value)
                })
            }
        },
        setMax() {
            const value = prompt('Please input the Max Amount', '1')
            if (value !== null) {
                this.manager.filtered.forEach(item => {
                    item.MaxItemSets = parseInt(value)
                })
            }
        },
        update() {
            bus.game.updateLoot()
            this.$bvToast.toast('Loot updated!', { title: 'Info', solid: true })
        },
    },
})
